/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：314__part-1
 */

"use strict"

var o
var r
import * as /* [auto-meaningful-name] */Module_11 from /* 11 */"./11"
import * as /* [auto-meaningful-name] */Module_75 from /* 75 */"./75"
import * as /* [auto-meaningful-name] */Module_83 from /* 83 */"./83"
var /* [auto-meaningful-name] */IconWidgetOldButton = "icon-widget-old-button"
r = {}
Module_11.a(r, Module_83.c.TINY, {
  height: 32,
  fontSize: 20,
  maxWidth: Module_75.e,
  minWidth: 32
})
Module_11.a(r, Module_83.c.SMALL, {
  height: 40,
  fontSize: 24,
  maxWidth: Module_75.e,
  minWidth: 40
})
Module_11.a(r, Module_83.c.MEDIUM, {
  height: 56,
  fontSize: 24,
  maxWidth: Module_75.e,
  minWidth: 56
})
Module_11.a(r, Module_83.c.LARGE, {
  height: 80,
  fontSize: 44,
  maxWidth: Module_75.e,
  minWidth: 80
})
Module_11.a(r, Module_83.c.HUGE, {
  height: 112,
  fontSize: 52,
  maxWidth: Module_75.e,
  minWidth: 112
})
var l = r
o = {}
Module_11.a(o, Module_83.c.TINY, {
  height: 28,
  fontSize: 12,
  maxWidth: Module_75.e,
  minWidth: 64
})
Module_11.a(o, Module_83.c.SMALL, {
  height: 28,
  fontSize: 12,
  maxWidth: Module_75.e,
  minWidth: 64
})
Module_11.a(o, Module_83.c.MEDIUM, {
  height: 40,
  fontSize: 16,
  maxWidth: Module_75.e,
  minWidth: 68
})
Module_11.a(o, Module_83.c.LARGE, {
  height: 52,
  fontSize: 20,
  maxWidth: Module_75.e,
  minWidth: 78
})
Module_11.a(o, Module_83.c.HUGE, {
  height: 52,
  fontSize: 20,
  maxWidth: Module_75.e,
  minWidth: 78
})
var u = o
var /* [auto-meaningful-name] */_148cefff = "#148cefff"
var p = false
var f = false
export { IconWidgetOldButton as c }
export { l }
export { u }
export { _148cefff as d }
export { p }
export { f }
